import { useEffect, useState } from 'react';
import apiCubic from 'config/api-cubic';
import { INIT_UI_LANGUAGE } from 'constants/languages';

const BASE = 'https://lifecell.volia.com';

const useCreateLifecellPaymentLink = ({ contractCode, customerRef, id = null, assetType = null } = {}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [link, setLink] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true);
        const { data: tokenKey } = await apiCubic.post({
          endpoint: apiCubic.endpoints.getLoginToken,
          data: {
            ottCustomerId: customerRef,
          },
        });

        const lang = INIT_UI_LANGUAGE;

        const params = new URLSearchParams({
          lang,
          contractCode,
          tokenKey: tokenKey.token,
          id,
          assetType,
        });

        setLink(`${BASE}?${params}`);
      } finally {
        setIsLoading(false);
      }
    };

    load();
  }, [assetType, contractCode, customerRef, id]);

  return { isLoading, link };
};

export default useCreateLifecellPaymentLink;
